/**
 * SkipToMainContent
 */
import React from 'react';
import { Grid, Cell } from 'ui-component-library/base';
/** Skip navigation and jump to main content using tab key. */
var SkipToMainContent = function (_a) {
    var href = _a.href, children = _a.children;
    return (React.createElement(Grid, { padding: false, className: "pl-4 lg:pl-6" },
        React.createElement(Cell, { span: 12 },
            React.createElement("a", { href: href, "data-cid": "SkipToMainContent", className: " p-2 no-underline sr-only focus:not-sr-only text-skipToMainContent-text-color" }, children))));
};
export default SkipToMainContent;
